export const ACCOUNT_COVERAGE_STORAGE_KEY = 'snp-account-coverage';
export const ACCOUNT_DETAILS_STORAGE_KEY = 'snp-account-details';
export const ACCOUNT_DETAILS_ACTIVE_TAB_STORAGE_KEY =
  'snp-account-details-active-tab';

export const RECENTLY_VIEWED_ACCOUNT_IDS_STORAGE_KEY =
  'snp-recently-viewed-account-ids';

export const ACCOUNTS_MY_COVERAGE_STORAGE_KEY = 'snp-accounts-my-coverage';
